import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { ArrowLeft } from "../../../assets/images";

type AppProps = {
  modal: boolean;
  toggleModal: () => void;
  setOtp: React.Dispatch<React.SetStateAction<string>>;
  otp:string;
  handleVerify:()=>void;
};

const OtpModal = ({ modal, toggleModal , otp , setOtp , handleVerify }: AppProps) => {

  const handleChange=(e:any)=>{
      setOtp(e.target.value)
  }

  const handleMaxLengthCheck = (e: any) => {
    if (e?.target.value.length > e?.target.maxLength) {
        e.target.value = e.target.value.slice(0, e.target.maxLength);
            setOtp(e?.target.value)
    }
};
  return (
    <Modal
      backdrop="static"
      isOpen={modal}
      toggle={toggleModal}
      size="l"
    >
      <ModalHeader toggle={toggleModal}>Verify OTP</ModalHeader>
      <ModalBody>
        <>
          <div>
            <span>
              <span></span>
             
              {/* <h5 className="mt-3 mb-2">Verify Mobile Number</h5> */}
              <p className="description">
                We have successfully sent 6 digit OTP to your number. Please
                enter below to verify your identity.
              </p>
            </span>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="otp">OTP</label>
                <input
                  type="number"
                  name="otp"
                  className="form-control"
                  value={otp}
                  placeholder="6 digit OTP"
                  autoFocus
                  width={"40%"}
                  style={{width:"50%"}}
                  onChange={(e:any) =>handleChange(e) }
                  maxLength={6}
                  onInput={handleMaxLengthCheck}
                  onWheel={(event) => event.currentTarget.blur()}
                />
              </div>
            </div>
            <div className="mb-3 mt-4">
              <button
                type="submit"
                className="btn btn-primary w-100"
                disabled={false}
                onClick={handleVerify}
              >
                Verify & Submit
              </button>
            </div>
            
          </div>
        </>
      </ModalBody>
    </Modal>
  );
};

export default OtpModal;
